var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info",on:{"click":_vm.login_out}},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.user.avatar}}),_c('div',{staticClass:"nickname"},[_vm._v(_vm._s(_vm.user.nickname))])])}
var staticRenderFns = []

export { render, staticRenderFns }